import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import config from "./config";
import { authFetch, handleApiResponse } from "./api/authFetch";
import { adminColors } from "./theme/adminTheme";

// Thin wrapper mounted at bare `/chat`. Resolves to the user's most
// recently updated thread, or creates a new one if they have none, then
// redirects to `/chat/:conversationId` - the actual chat UI lives there.
function ChatEntry() {
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const resolveThread = async () => {
      try {
        const res = await authFetch(`${config.API_BASE_URL}/chats`);
        const threads = await handleApiResponse(res, navigate);
        if (threads === null) return; // redirected to signin

        if (threads.length > 0) {
          navigate(`/chat/${threads[0].id}`, { replace: true });
          return;
        }

        const createRes = await authFetch(`${config.API_BASE_URL}/chats`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        const newThread = await handleApiResponse(createRes, navigate);
        if (newThread === null) return; // redirected to signin

        navigate(`/chat/${newThread.id}`, { replace: true });
      } catch (error) {
        console.error("Failed to resolve a chat thread:", error);
      }
    };

    resolveThread();
  }, [navigate]);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress size={28} sx={{ color: adminColors.accent }} />
    </Box>
  );
}

export default ChatEntry;
